import { MessageSquare } from 'lucide-react';

interface Props {
    count: number;
    onClick: () => void;
    size?: 'sm' | 'md';
}

export function CommentBadge({ count, onClick, size = 'sm' }: Props) {
    const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
    const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

    return (
        <button
            onClick={e => { e.stopPropagation(); onClick(); }}
            className={`inline-flex items-center gap-0.5 rounded px-1 py-0.5 ${textSize} transition-colors ${
                count > 0
                    ? 'text-blue-600 hover:bg-blue-50'
                    : 'text-gray-400 hover:bg-gray-50'
            }`}
            title={`${count} comment${count !== 1 ? 's' : ''}`}
        >
            <MessageSquare className={iconSize} />
            {count > 0 && <span>{count}</span>}
        </button>
    );
}
